import {
    UPDATE_MODULE_ERROR,
    UPDATE_MODULE_SUCCESS
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case UPDATE_MODULE_SUCCESS:
          return {
            ...state,
            updateModuleData: action.payload,
          };
        case UPDATE_MODULE_ERROR:
          return {
            ...state,
            updateModuleError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    